<template>
    <main-table-layout
        sub-menu-selector="librarypanel"
    >
        <div slot="buttonsRight"/>
        <content-filter slot="filter"
                        id="textList"
                        @filter="filter"
                        store-name="Text"
        />
        <view-switcher
                slot="mainContentButtons"
                id="mainContent"
                :table="true"
                :thumbnails="true"/>
        <pagination
                slot="mainContentButtons"
                :limit="paginationLimit"
                :total="$store.getters.getTextListOptions('textList', 'pagination_items')"
                id="texttablepage"
                @setActive="loadPaginatedData"
                ref="pagination"
        />
        <Button
            permission="create"
                type="action-button"
                slot="mainContentButtons"
                link="/library/texts/add"
                icon="plus">
            {{ $t('createNewText') }}
        </Button>

      <Button
           slot="mainContent"
           @click="loadPaginatedData(0); $refs.pagination.setActive(0)"
           type="reload"
           icon="rotate-right"
           class="icon-button"
       />
        <table-widget
                v-if="$store.getters.getViewSwitcher($route.name, 'mainContent') === 'table'"
                slot="mainContent"
                id="appsDefaultTable"
                :fields="fields"
                :data="$store.getters.getTexts"
                :title-as-links="true"
                @sort="sort"
                :nav-by-clicking-row="true"
                :deletable="true"
                @deleteRow="deleteRow"
                :show-tags="true"
                :show-organization="true"
                edit-permission="write"
                delete-permission="delete"
                :use-team-permission="true"
                :loading="loading"
        />
        <thumbnails
                v-if="$store.getters.getViewSwitcher($route.name, 'mainContent') === 'thumbnails'"
                slot="mainContent"
                id="appsDefaultTable"
                :fields="thumbnailFields"
                :data="$store.getters.getTexts"
                :title-as-links="true"
                @sort="sort"
                :deletable="true"
                @deleteRow="deleteRow"
                :nav-by-clicking-row="true"
                edit-permission="write"
                delete-permission="delete"
                :use-team-permission="true"
                :loading="loading"
        />
    </main-table-layout>
</template>

<script>
    import Button from "../components/forms/Button";
    import TableWidget from "../components/widgets/TableWidget";
    import ContentFilter from "../components/widgets/filter/ContentFilter";
    import MainTableLayout from "../layouts/MainTableLayout";
    import ViewSwitcher from "../components/widgets/ViewSwitcher";
    import Thumbnails from "../components/widgets/ThumbnailView";
    import Pagination from "../components/Pagination";

    export default {
        name: 'Texts',
        components: {
            Button,
            TableWidget,
            ContentFilter,
            MainTableLayout,
            ViewSwitcher,
            Thumbnails,
            Pagination,
        },
        data() {
            return {
                loading: true,
                offset: 0,
                paginationLimit: 15,
                queryRelevantComponents: 2, //pagination and filter
                queryRelevantInits: 0,
                listName: 'textdefaultTable',
                sorting: '-updatedAt',
                fields: [{
                    name: '',
                    id: 'icon',
                    type: 'icon',
                    virtual: true,
                    fieldId: 'type'
                    },
                    {
                        name: 'Name',
                        id: 'name',
                        type: 'string',
                        sortable: true
                    },
                    {
                        name: 'Type',
                        id: 'type',
                        type: 'string',
                    },
                    {
                        name: 'Last Update',
                        id: 'updatedAt',
                        type: 'date',
                        sortable: true
                    },
                    {
                        name: 'Edit',
                        type: 'editButton'
                    },
                ],
                thumbnailFields: [{
                    name: '',
                    id: 'icon',
                    type: 'icon',
                    virtual: true,
                    fieldId: 'type'
                },
                    {
                        name: 'Organization',
                        id:'organization',
                        type: 'organization',
                        sortable: true
                    },
                    {
                        name: 'Type',
                        id: 'type',
                        type: 'string',
                        sortable: true
                    },
                    {
                        name: 'Last Update',
                        id: 'updatedAt',
                        type: 'date',
                        sortable: true
                    },
                    {
                        name: 'Name',
                        id: 'name',
                        type: 'string',
                        sortable: true
                    },
                    {
                        name: 'Tags',
                        id:'tags',
                        type: 'tags',
                    },
                    {
                        name: 'Edit',
                        type: 'editButton'
                    },
                ]
            }
        },
        watch: {
          queryRelevantInits: function(newval) {
            if(newval === this.queryRelevantComponents) {
              this.loadData( false);
            }
          }
        },
        methods: {
            loadPaginatedData(offset, initial) {
              this.offset = offset;
              this.loadData(initial);
            },
          loadData(initial = false) {
            this.loading = true;
            let args = {
              add: {
                paging: {
                  [this.listName]: true,
                },
                offset: {
                  [this.listName]: this.offset,
                },
                limit: {
                  [this.listName]: this.paginationLimit,
                },
                sort: {
                  [this.listName]: this.sorting,
                }
              }
            };
            if(initial) {
              this.queryRelevantInits++;
              this.$store.dispatch('registerTextsQueryParams', args);
            }
            else {
              this.$store.dispatch('loadTexts', args).then(() => {
                this.loading = false;
              })
            }
          },
            deleteRow: function (id) {
                this.$store.dispatch('deleteText', {
                    args: [id]
                }).then(() => {
                  this.loadPaginatedData(0);
                })
            },
            filter: function(args, initial) {
                if(initial) {
                    this.queryRelevantInits++;
                    this.$store.dispatch('registerTextsQueryParams', args);
                }
                else {
                  this.loading = true;
                    this.$store.dispatch('loadTexts', args).then(() => {
                      this.loading = false;
                    })
                }
            },
            sort(args) {
              const {fieldname, direction} = args;
              const sortString = direction + fieldname;
              if(this.sorting !== sortString) {
                this.sorting = sortString;
              }
              this.loadPaginatedData(0);
            }
        }
    }
</script>
